import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

const Wrapper = ({ children, className }) => {
  const classes = classNames({
    'pro-wrapper': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

Wrapper.propTypes = propTypes;

export default Wrapper;
